export const groupLabels = ['Best match', 'different engine details', 'different variant', 'different spec', 'different years'];
export const fieldLabel = field => ({ model_family_id: 'model', family_id: 'model', exact_model_id: 'model', canonical_part_id: 'part', make_id: 'make', variant_id: 'variant' })[field] || String(field).replaceAll('_', ' ');
export const pairKey = (part, supplier) => `${part}:${supplier}`;
export const possiblySent = (part, supplier) => supplier?.possibly_sent === true || part.sent?.possibly_sent_supplier_ids?.includes(supplier?.supplier_id) === true;
export const needsResend = (part, supplier) => supplier?.already_sent === true || part.sent?.supplier_ids?.includes(supplier?.supplier_id) === true || possiblySent(part, supplier);
export function matchedPair(part, group, supplier) {
  return { supplier_id: supplier.supplier_id, query_part_id: part.query_part_id, source: 'match', level: group.level, capability_id: supplier.capability_id, ...(needsResend(part, supplier) ? { resend: true } : {}) };
}
export function defaultPairs(plan) {
  const pairs = {};
  for (const part of plan.parts || []) {
    if (part.sent?.groups_sent?.length || part.sent?.supplier_ids?.length) continue;
    for (const group of part.groups || []) if (group.level === 0) {
      for (const supplier of group.suppliers || []) if (!needsResend(part, supplier)) pairs[pairKey(part.query_part_id, supplier.supplier_id)] = matchedPair(part, group, supplier);
    }
  }
  return pairs;
}
export function selectNextGroup(pairs, part) {
  const next = { ...pairs };
  const group = part.groups?.find(item => item.level === part.next_group_level);
  for (const supplier of group?.suppliers || []) if (!needsResend(part, supplier)) next[pairKey(part.query_part_id, supplier.supplier_id)] = matchedPair(part, group, supplier);
  return next;
}
export function recipientsFor(pairs) {
  const recipients = new Map();
  for (const pair of Object.values(pairs)) {
    const { supplier_id, ...part } = pair;
    if (!recipients.has(supplier_id)) recipients.set(supplier_id, { supplier_id, parts: [] });
    recipients.get(supplier_id).parts.push(part);
  }
  return [...recipients.values()];
}
export function addManualPairs(pairs, supplierId, partIds, plan) {
  const next = { ...pairs };
  for (const id of partIds) {
    const part = plan.parts.find(part => part.query_part_id === id);
    const sent = part && needsResend(part, { supplier_id: supplierId });
    next[pairKey(id, supplierId)] = { supplier_id: supplierId, query_part_id: id, source: 'manual', ...(sent ? { resend: true } : {}) };
  }
  return next;
}
export const vehicleFields = ['brand', 'model', 'year', 'variant', 'trim_info', 'country_spec', 'vin', 'engine_code', 'engine_displacement', 'engine_layout', 'transmission_type', 'transmission_code', 'drivetrain', 'fuel_type'];
export const partFields = ['part_number', 'side', 'quantity', 'condition'];
export const mandatoryVehicleFields = new Set(['brand', 'model', 'year', 'vin', 'country_spec']);
export const vehicleValue = (vehicle, field) => field === 'brand' ? vehicle?.brand_name || vehicle?.brand : field === 'model' ? vehicle?.model_name || vehicle?.model : vehicle?.[field];
export function selectionFor(composer, parts) {
  return { vehicle_fields: composer.vehicle_fields, image_ids: composer.image_ids, additional_info: composer.additional_info,
    part_fields: Object.fromEntries(parts.map(id => [id, composer.part_fields[id] || []])) };
}
export function composeDefaults(task, plan, history) {
  return {
    vehicle_fields: vehicleFields.filter(field => vehicleValue(task.vehicle, field) != null && vehicleValue(task.vehicle, field) !== ''),
    image_ids: task.images || [], additional_info: '',
    part_fields: Object.fromEntries((plan.parts || []).map(part => [part.query_part_id, [...partFields]])),
    is_international: !!task.customer?.customer_mobile && !String(task.customer.customer_mobile).replace(/^\+/, '').startsWith('971'),
    send_acknowledgement: !(history.sends || []).length,
  };
}
export const frozenBody = (composer, pairs, team = []) => ({ selection: selectionFor(composer, [...new Set([...Object.values(pairs).map(pair => pair.query_part_id), ...team.flatMap(member => member.pending_query_part_ids)])]),
  is_international: composer.is_international, send_acknowledgement: composer.send_acknowledgement, recipients: recipientsFor(pairs), ...(composer.automation ? { automation: composer.automation } : {}) });
export function repairSelection(pairs, error) {
  const code = error?.response?.data?.code || error?.code, data = error?.response?.data?.data || error?.data || {};
  const next = { ...pairs };
  if (code === 'DUPLICATE_PHONE') {
    const ids = data.supplier_ids || [], keep = ids.find(id => Object.values(next).some(pair => pair.supplier_id === id));
    Object.entries(next).forEach(([key, pair]) => { if (ids.includes(pair.supplier_id) && pair.supplier_id !== keep) delete next[key]; });
  }
  if (code === 'ALREADY_SENT') for (const pair of data.pairs || []) delete next[pairKey(pair.query_part_id, pair.supplier_id)];
  return next;
}
export const errorGuidance = {
  RECIPIENT_HAS_NO_PHOTOS: 'A supplier would get no photos. Choose a General photo or tag one to their part. Reloaded.',
  MATCH_CHANGED: 'Matches changed since you opened this. Reloaded.', ALREADY_SENT: 'Already sent. Tick Resend to send again.',
  DUPLICATE_PHONE: 'These suppliers share a phone number. Only one can be selected.', FOREIGN_OR_INACTIVE_PART: 'A part changed. Reloaded.',
  MESSAGING_OUTREACH_IMAGES_REQUIRED: 'Choose at least one photo.', MESSAGING_OUTREACH_ALREADY_PENDING: 'Another send for this query is running. Try again in a moment.',
  MESSAGING_OUTREACH_EXECUTOR_BUSY: 'Another send for this query is running. Try again in a moment.', IDEMPOTENCY_KEY_REUSED: 'Internal request conflict. Reload; do not start another send.',
  ENQUIRIES_DISABLED: 'Sending to suppliers is switched off. Ask an administrator.',
  TEAM_MEMBER_UNAVAILABLE: 'A team member changed. Reloaded.',
};
